import React from "react";
import { ArrowUpRight, ArrowDownRight, ArrowRight, Sparkles, Info } from "lucide-react";

const fmt = (unit, v) => {
  if (v == null) return "–";
  if (unit === "chf") return `CHF ${Number(v).toLocaleString("de-CH", { maximumFractionDigits: 0 })}`;
  if (unit === "pct") return `${Number(v).toFixed(1)} %`;
  return String(Math.round(v));
};
const change = (c) => c.change_text || "–";
const ICON = { up: ArrowUpRight, down: ArrowDownRight, flat: ArrowRight };
const TONE = { positive: "text-emerald-700 bg-emerald-50", negative: "text-rose-700 bg-rose-50", neutral: "text-slate-600 bg-slate-100" };

/** Vorjahresvergleich pro Kennzahl: Pfeil, Veränderung und (KI-)Kommentar. */
export function ManagementReportComparison({ kpis, year }) {
  const rows = kpis?.vergleich || [];
  if (!rows.length) return null;
  return (
    <div className="mb-4 rounded-lg border border-slate-200 overflow-hidden" data-testid="management-report-comparison">
      <div className="px-3 py-2 bg-slate-50 border-b border-slate-200 flex flex-wrap items-center justify-between gap-2">
        <span className="text-xs font-semibold text-slate-800">Vorjahresvergleich {year - 1} → {year}</span>
        {!kpis.vorjahr_vorhanden && <span className="inline-flex items-center gap-1 text-[11px] text-amber-800 bg-amber-50 rounded px-2 py-0.5" data-testid="management-report-no-prior"><Info className="h-3 w-3" />Kein Vorjahr vorhanden – erstes Geschäftsjahr</span>}
      </div>
      <div className="divide-y divide-slate-100">
        {rows.map((c) => { const Icon = ICON[c.direction] || ArrowRight; return (
          <div key={c.key} className="grid grid-cols-[1fr_auto] sm:grid-cols-[170px_1fr_1fr_110px_2fr] gap-x-3 gap-y-1 px-3 py-2 text-xs items-center" data-testid={`management-report-cmp-${c.key}`}>
            <span className="font-medium text-slate-800">{c.label}</span>
            <span className="text-slate-900 tabular-nums sm:text-right">{fmt(c.unit, c.current)}</span>
            <span className="text-slate-500 tabular-nums sm:text-right hidden sm:block">{fmt(c.unit, c.previous)}</span>
            <span className={`inline-flex items-center gap-1 rounded-full px-2 py-0.5 justify-self-start sm:justify-self-end tabular-nums ${TONE[c.trend] || TONE.neutral}`} data-testid={`management-report-cmp-${c.key}-change`}><Icon className="h-3.5 w-3.5" />{change(c)}</span>
            <span className="col-span-2 sm:col-span-1 text-slate-600 leading-snug inline-flex items-start gap-1">{c.comment_source === "ai" && <Sparkles className="h-3 w-3 text-violet-600 mt-0.5 shrink-0" />}{c.comment}</span>
          </div>
        ); })}
      </div>
    </div>
  );
}
